<template>
  <div class="entity">
    <el-carousel indicator-position="outside" v-if="carouselList.length">
      <el-carousel-item v-for="(item, i) in carouselList" :key="i">
        <img class="mainImg" :src="item.pic.replace('s_', '')" >
        <div class="mainInfo">{{ item.info }}</div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { postDetail, postAbout } from "@/api/company";

export default {
  name: "entity",
  data() {
    return {
      carouselList: []
    };
  },
  mounted() {
    const webName = this.$router.history.current.params.name;
    this.postDetail(webName);
  },
  methods: {
    // 详情
    postDetail(name) {
      postDetail({
        web_name: name,
      }).then((res) => {
        this.postAbout(res.data.organ_id);
      });
    },
    // 关于我们
    postAbout(id) {
      postAbout({
        organCode: id,
      }).then((res) => {
        this.carouselList = res.data.store_show;
        console.log("关于我们", res.data);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>